import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-guest',
  templateUrl: './guest.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './guest.component.scss'
})
export class GuestComponent {

}
